// extracted by css-extract-rspack-plugin
module.exports =  {"icon":"Report__icon--EMxdY","print":"Report__print--f3fs7","newline":"Report__newline--xBAjC"};